import { SortSportEnum } from "@/components/homepage/SortSport";
import { LEAGUES, type League, SPORTS, type Sport, TABS, type Tab } from "@/pages/Tournaments/constant";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
export interface IHomePageStore {
  selectedLeague: League;
  setSelectedLeague: (league: League) => void;
  selectedTab: Tab;
  setSelectedTab: (tab: Tab) => void;
  selectedSortType: SortSportEnum;
  setSelectedSortType: (sortType: SortSportEnum) => void;
  selectedSport: Sport;
  setSelectedSport: (sport: Sport) => void;

  isOpenMyPageSidebar: boolean;
  setIsOpenMyPageSidebar: (isOpen: boolean) => void;
}

export const useHomePageStore = create<IHomePageStore>((set) => ({
  selectedLeague: LEAGUES[0],
  selectedSortType: SortSportEnum.EARLIEST_EVENT_DATE,
  selectedSport: SPORTS[0],
  isOpenMyPageSidebar: false,
  selectedTab: TABS[0],

  setSelectedLeague: (league: League) => set({ selectedLeague: league }),
  setSelectedSport: (sport: Sport) => set({ selectedSport: sport }),
  setSelectedSortType: (sortType: SortSportEnum) => set({ selectedSortType: sortType }),
  setSelectedTab: (tab: Tab) => set({ selectedTab: tab }),
  setIsOpenMyPageSidebar: (isOpen: boolean) => set({ isOpenMyPageSidebar: isOpen }),
}));

interface ISkipPrizesStore {
  skipPrizes: boolean;
  setSkipPrizes: (skip: boolean) => void;
}

export const useSkipPrizesStore = create<ISkipPrizesStore>()(
  persist(
    (set) => ({
      skipPrizes: false,
      setSkipPrizes: (skip: boolean) => set({ skipPrizes: skip }),
    }),
    {
      name: "skip-prizes-store",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export interface IFirstVisitStore {
  isFirstVisit: boolean;
  setIsFirstVisit: (isFirstVisit: boolean) => void;
}

// This store is intentionally in-memory only (not persisted to localStorage)
// so that isFirstVisit resets to true when the page is refreshed
export const useFirstVisitStore = create<IFirstVisitStore>()(
  persist(
    (set) => ({
      isFirstVisit: true,
      setIsFirstVisit: (isFirstVisit: boolean) => set({ isFirstVisit }),
    }),
    {
      name: "first-visit-store",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
